import { render, staticRenderFns } from "./ActiveUserModal.vue?vue&type=template&id=4c2f20fc"
import script from "./ActiveUserModal.vue?vue&type=script&lang=js"
export * from "./ActiveUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports